import { GenericFunction } from '../GenericFunction';
import { Stepper } from '../../Merge/Stepper/Stepper';
import { Tracker } from './Tracker';
import { convertToSeries } from '../../Util';

const _ = require('lodash');

export const signals = {
  BREAK_ITERATIONS: 'break_ar_function_iteration'
}

export const outputs = {
  START_OF_PERIOD: 'start_of_period_output',
  END_OF_PERIOD: 'end_of_period_output'
}



/**
 * 
 */
export class ARFunction extends GenericFunction {
  constructor(f, {label, parameters = [], maxIterations = 100, outputType = outputs.START_OF_PERIOD} = {}) {
    super(f, {label, parameters, maxInputSize: Infinity});
    this.selfKey = this.parameters.find(i => i.type === 'self').name;
    this.maxIterations = maxIterations;
    this.outputType = outputType;
  }

  hideFirst(arr) {
    return arr.slice(1);
  }

  hideLast(arr) {
    return arr.slice(0, arr.length-1);
  }

  wrapOutput(indices, values) {
    let series;

    let equalLength = (indices.length === values.length);
    let moreValues = (indices.length === (values.length-1));
    let startValue = (this.outputType === outputs.START_OF_PERIOD);

    if (equalLength && startValue) {
      series = _.zip(indices, values);
    } else if (moreValues && startValue) {
      series = _.zip(indices, this.hideLast(values));
    } else if (equalLength && !startValue) {
      series = _.zip(this.hideLast(indices), this.hideFirst(values));
    } else if (moreValues && !startValue) {
      series = _.zip(indices, this.hideFirst(values));
    }

    return convertToSeries(series);
  }

  setupTracker(output, inputArgs) {
    let argumentsClone = {...inputArgs};

    let selfTracker = new Tracker(output, argumentsClone[this.selfKey]);
    argumentsClone[this.selfKey] = selfTracker;

    return argumentsClone;
  }

  applyIteratively(args = {}) {
    let indexOutput = [0];
    let valueOutput = [args[this.selfKey]];
    
    let trackedArgs = this.setupTracker(valueOutput, args);
    
    for (let index = indexOutput.length; index < this.maxIterations; index++) {
      let value = this(trackedArgs);

      if (value === signals.BREAK_ITERATIONS) {
        break;
      } else {
        indexOutput.push(index);
        valueOutput.push(value);
      }
    }

    return this.wrapOutput(indexOutput, valueOutput);
  }

  applyToTimeSeries(args = {}) {
    let indexOutput = [];
    let valueOutput = [args[this.selfKey]];

    let trackedArgs = this.setupTracker(valueOutput, args);
    
    let mergeIterator = new Stepper(trackedArgs);

    for (const datum of mergeIterator) {
      let value = this(datum.values);

      if (value === signals.BREAK_ITERATIONS) {
        break;
      } else {
        indexOutput.push(datum.index);
        valueOutput.push(value);
      }
    }

    return this.wrapOutput(indexOutput, valueOutput);
  }
}